import axios from '@/libs/api.request'

/**
 * 所有商品列表
 */
export const allGoods = () => {
    return axios.request({
        url: '/api/admin/goods/allGoods',
        method: 'post'
    })
}

/**
 * 所有推广者列表
 */
export const allPromotionMember = () => {
    return axios.request({
        url: '/api/admin/promotionmember/allPromotionMember',
        method: 'post'
    })
}

/**
 * 待结算详情
 */
 export const settedInfo = (member_id) => {
    let data ={
        "member_id": member_id
    }
    return axios.request({
        url: '/api/admin/promotionsettled/settedInfo',
        data,
        method: 'post'
    })
}
